var map = {
	"./CheckMark.svg": 236,
	"./CheckMarkA.svg": 893,
	"./GoogleLogoIcon.svg": 946,
	"./MicrosoftLogoIcon.svg": 781,
	"./XMark.svg": 392,
	"./XMarkA.svg": 441,
	"./discord.png": 635,
	"./slack.png": 155,
	"./teams.png": 601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 548;